module.exports = __webpack_public_path__ + "img/exam-content-organization.9fca2b27.png";